import React from 'react';
import Styles from './FeatureCard.module.less';
import { Card } from '../../Card';
import { classes } from '../../../lib';
import { Button } from '../../Button';
import { LpLink } from '../LpLink';

export type FeatureCardProps = {
    children: React.ReactNode;
    subtitle: string;
    title: string;
    image: React.ReactNode;
    buttonText: string;
    href: string;
};

export const FeatureCard = ({
    children,
    subtitle,
    title,
    buttonText,
    image,
    href,
}: FeatureCardProps): JSX.Element => {
    return (
        <Card elevation="clickable" className="flex">
            <LpLink
                to={href}
                className={classes(
                    'vertical stretch-top g16 p16',
                    Styles.container
                )}>
                <div
                    className={classes(
                        'vertical center-middle py40',
                        Styles.imageContainer
                    )}>
                    {image}
                </div>
                <div
                    className={classes(
                        'vertical stretch-top g8',
                        Styles.content
                    )}>
                    <h4>{title}</h4>
                    <p className="secondary-text medium-alude">{subtitle}</p>
                    <div
                        className={classes(
                            Styles.description,
                            'secondary-text medium-alude'
                        )}>
                        {children}
                    </div>
                </div>
                <Button type="link" className="self-left">
                    {buttonText}
                </Button>
            </LpLink>
        </Card>
    );
};
